import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'theme'

// Toggles daisyUI theme (light/dark) via data-theme on <html>; remembers the choice in localStorage.
export default class ThemeController extends Controller<HTMLInputElement> {
  override connect(): void {
    const saved = readTheme()
    const current = saved ?? (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    this.element.checked = current === 'dark'
    if (saved) document.documentElement.dataset['theme'] = saved
  }

  toggle(): void {
    const theme = this.element.checked ? 'dark' : 'light'
    document.documentElement.dataset['theme'] = theme
    try { localStorage.setItem(STORAGE_KEY, theme) } catch { /* storage unavailable */ }
  }
}

function readTheme(): 'light' | 'dark' | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return value === 'light' || value === 'dark' ? value : null
  } catch {
    return null
  }
}
